import React from "react";

import clsx from "clsx";
import { SortDirection } from "@mui/material";

import { Sort } from "@/components/atoms";
import { SortOrder } from "@/shared/domain";

import { SortableLabel, StyledTableHeaderCell } from "./styled";

type SortableTableHeaderProps<SortPropertyType> = {
    labelKey: SortPropertyType;
    orderBy: Sort<SortPropertyType>; // name (asc) or -name (desc)
    onSort: (key: SortPropertyType) => void;
    className?: string;
    children: React.ReactNode;
};

const SortableTableHeader = <SortPropertyType,>({
    labelKey,
    onSort,
    orderBy,
    className,
    children,
}: SortableTableHeaderProps<SortPropertyType>) => {
    const isColumnSorted = orderBy.property === labelKey;

    const handleSort = () => {
        onSort(labelKey);
    };

    const sortDirection: SortDirection = orderBy.order === SortOrder.Descending ? "desc" : "asc";
    return (
        <StyledTableHeaderCell
            key={`label-${labelKey}`}
            align="left"
            padding="normal"
            className={clsx("headerCell", className)}
            sortDirection={isColumnSorted ? sortDirection : false}
            data-testid={`table_sort_header-button-${labelKey}`}
        >
            <SortableLabel
                $active={isColumnSorted}
                className={clsx("label", isColumnSorted && "active")}
                direction={isColumnSorted ? sortDirection : "asc"}
                onClick={handleSort}
            >
                {children}
            </SortableLabel>
        </StyledTableHeaderCell>
    );
};

export default SortableTableHeader;
